import React from 'react';
import cl from './Loader.module.css'


const Loader = () => {
    return ( 
        <p className={cl.isLoading}>Идет загрузка...</p>
    )
};

export default Loader;
